<div class="personal-information">
    <div
        class="fixed z-20 top-0 right-0 left-0 pl-5 pr-6 h-12 bg-green-500 w-full flex items-center justify-between font-bold">
        <div class="text-white">Profile</div>
        <div>
            <p-button icon="pi pi-times" [rounded]="true" [text]="true" (click)="closeDialog()"
                class="[&_button]:bg-transparent [&_.p-button:disabled]:opacity-50 [&_.p-button-icon]:text-md [&_.p-button-icon]:text-white" />
        </div>
    </div>
    <div class="space-y-4 p-4">

        <!-- Personal Information Section -->
        <div class="bg-white rounded-lg p-6 shadow-sm">
            <h3 class="text-lg font-semibold text-gray-800 mb-4">Personal Information</h3>
            <div class="space-y-4">
                <div class="flex justify-between py-2 border-b border-gray-100">
                    <span class="text-gray-600 font-light">Full Name</span>
                    <span class="font-semibold">{{ userProfile.onboarding?.fullName || 'Not specified' }}</span>
                </div>
                <div class="flex justify-between py-2 border-b border-gray-100">
                    <span class="text-gray-600 font-light">Email</span>
                    <span class="font-semibold">{{ userProfile.onboarding?.email || 'Not specified' }}</span>
                </div>
                <div class="flex justify-between py-2 border-b border-gray-100">
                    <span class="text-gray-600 font-light">Date of Birth</span>
                    <span class="font-semibold">{{ formatDate(userProfile.onboarding?.dateOfBirth || '') }}</span>
                </div>
                <div class="flex justify-between py-2">
                    <span class="text-gray-600 font-light">Address</span>
                    <span class="font-semibold text-right">{{ userProfile.onboarding?.address || 'Not specified'
                        }}</span>
                </div>
            </div>
        </div>

        <!-- Vehicle Information Section -->
        <div class="bg-white rounded-lg p-6 shadow-sm">
            <h3 class="text-lg font-semibold text-gray-800 mb-4">Vehicle Information</h3>
            <div class="space-y-4">
                <div class="flex justify-between py-2 border-b border-gray-100">
                    <span class="text-gray-600 font-light">Own 4-Wheel Vehicle</span>
                    <span class="font-semibold">{{ getYesNoLabel(userProfile.onboarding?.hasVehicle || '') }}</span>
                </div>
                <div class="flex justify-between py-2 border-b border-gray-100">
                    <span class="text-gray-600 font-light">Vehicle Type</span>
                    <span class="font-semibold">{{ getVehicleTypeLabel(userProfile.onboarding?.vehicleType || '')
                        }}</span>
                </div>
                <div class="flex justify-between py-2">
                    <span class="text-gray-600 font-light">Vehicle Insurance</span>
                    <span class="font-semibold">{{ getYesNoLabel(userProfile.onboarding?.hasVehicleInsurance || '')
                        }}</span>
                </div>
            </div>
        </div>

        <!-- Experience Section -->
        <div class="bg-white rounded-lg p-6 shadow-sm">
            <h3 class="text-lg font-semibold text-gray-800 mb-4">Shopping Experience</h3>
            <div class="space-y-4">
                <div class="flex justify-between py-2 border-b border-gray-100">
                    <span class="text-gray-600 font-light">Grocery Shopping Experience</span>
                    <span class="font-semibold text-right">{{
                        getExperienceLabel(userProfile.onboarding?.groceryShoppingExperience
                        || '') }}</span>
                </div>
                <div class="flex justify-between py-2">
                    <span class="text-gray-600 font-light">Experience with Other Apps</span>
                    <span class="font-semibold text-right">{{
                        getYesNoLabel(userProfile.onboarding?.hasOtherAppsExperience || '')
                        }}</span>
                </div>
            </div>
        </div>

        <!-- Verification Documents Section -->
        <div class="bg-white rounded-lg p-6 shadow-sm">
            <h3 class="text-lg font-semibold text-gray-800 mb-4">Verification Documents</h3>

            <!-- Driver's License -->
            <div class="mb-6">
                <h4 class="text-md font-medium text-gray-700 mb-3">Driver's License</h4>
                <div class="flex flex-wrap gap-3">
                    @for (image of userProfile.onboarding?.driversLicense || []; track $index) {
                    <div class="relative">
                        <p-image
                            [imageStyle]="{'border-radius': '8px', 'width': '120px', 'height': '80px', 'object-fit': 'cover'}"
                            [src]="image.downloadUrl" alt="Driver's License" [preview]="true" />
                    </div>
                    } @empty {
                    <div class="text-gray-500 text-sm">No driver's license uploaded</div>
                    }
                </div>
            </div>

            <!-- Selfie with Driver's License -->
            <div class="mb-6">
                <h4 class="text-md font-medium text-gray-700 mb-3">Selfie with Driver's License</h4>
                <div class="flex flex-wrap gap-3">
                    @for (image of userProfile.onboarding?.selfie || []; track $index) {
                    <div class="relative">
                        <p-image
                            [imageStyle]="{'border-radius': '8px', 'width': '120px', 'height': '80px', 'object-fit': 'cover'}"
                            [src]="image.downloadUrl" alt="Selfie" [preview]="true" />
                    </div>
                    } @empty {
                    <div class="text-gray-500 text-sm">No selfie uploaded</div>
                    }
                </div>
            </div>

            <!-- Vehicle Insurance -->
            <div>
                <h4 class="text-md font-medium text-gray-700 mb-3">Vehicle Insurance</h4>
                <div class="flex flex-wrap gap-3">
                    @for (image of userProfile.onboarding?.vehicleInsurance || []; track $index) {
                    <div class="relative">
                        <p-image
                            [imageStyle]="{'border-radius': '8px', 'width': '120px', 'height': '80px', 'object-fit': 'cover'}"
                            [src]="image.downloadUrl" alt="Vehicle Insurance" [preview]="true" />
                    </div>
                    } @empty {
                    <div class="text-gray-500 text-sm">No vehicle insurance uploaded</div>
                    }
                </div>
            </div>
        </div>

        <!-- Account Status Section -->
        <div class="bg-white rounded-lg p-6 shadow-sm">
            <h3 class="text-lg font-semibold text-gray-800 mb-4">Account Status</h3>
            <div class="space-y-4">
                <div class="flex justify-between py-2 border-b border-gray-100">
                    <span class="text-gray-600 font-light">Onboarding Completed</span>
                    <span class="font-semibold"
                        [class]="userProfile.onboardingCompleted ? 'text-green-600' : 'text-red-600'">
                        {{ userProfile.onboardingCompleted ? 'Yes' : 'No' }}
                    </span>
                </div>
                @if (userProfile.onboarding?.completedOn) {
                <div class="flex justify-between py-2">
                    <span class="text-gray-600 font-light">Completed On</span>
                    <span class="font-semibold">{{ formatDate(userProfile.onboarding?.completedOnString || '')
                        }}</span>
                </div>
                }
            </div>
        </div>
    </div>
</div>